<template>
  <header class="app-header navbar">
    <button
      class="navbar-toggler mobile-sidebar-toggler d-lg-none"
      type="button"
      @click="mobileSidebarToggle"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="/">Dialogera</b-link>
    <button
      class="navbar-toggler sidebar-toggler d-md-down-none"
      type="button"
      @click="sidebarToggle"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <go-bar />
    <b-navbar-nav class="ml-auto">
      <HeaderDropdown />
    </b-navbar-nav>
  </header>
</template>
<script>
import HeaderDropdown from './HeaderDropdown.vue'
import GoBar from './GoBar.vue'
export default {
	name: 'c-header',
	props: {
		fixed: {
			type: Boolean,
			default: false,
		},
	},

	components: {
		GoBar,
		HeaderDropdown,
	},
	data() {
		return {}
	},
	methods: {
		sidebarToggle(e) {
			e.preventDefault()
			document.body.classList.toggle('sidebar-hidden')
		},
		sidebarMinimize(e) {
			e.preventDefault()
			document.body.classList.toggle('sidebar-minimized')
		},
		mobileSidebarToggle(e) {
			e.preventDefault()
			document.body.classList.toggle('sidebar-mobile-show')
		},
		asideToggle(e) {
			e.preventDefault()
			document.body.classList.toggle('aside-menu-hidden')
		},

		isFixed(fixed) {
			fixed ? document.body.classList.add('header-fixed') : document.body.classList.remove('header-fixed')
			return fixed
		},
	},
	watch: {
		//
	},
	mounted: function() {
		this.isFixed(this.fixed)
	},
}
</script>
